import * as React from 'react';


export default class Logout extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <path opacity="0.01" fillRule="evenodd" clipRule="evenodd" d="M1.46666 13.8113H3.08226V1.46704H1.46666V13.8113Z" fill="#53A9DE" />
        <path d="M10.1195 4.938V1.466H1.46657V13.9409H10.1195V10.3271" stroke="#727272" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.80179 7.83731H14.5905" stroke="#727272" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.5902 7.83732L12.2046 5.45172" stroke="#727272" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.2049 10.2226L14.5905 7.83704" stroke="#727272" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
}
